module.exports = __webpack_public_path__ + "img/swiper2.e92cca4d.jpg";